function weightedAvg(items) {
    let qtySum = 0;
    let notional = 0;
    for (const item of items) {
        if (item.qty === 0)
            continue;
        qtySum += item.qty;
        notional += item.qty * item.avg_price;
    }
    if (qtySum === 0)
        return null;
    return notional / qtySum;
}
/** Сливает позиции и PnL-строки по ticker; открытые сверху, затем остальные по алфавиту. */
export function mergePositionsWithPnl(positions, pnlTickers) {
    const openByTicker = new Map();
    for (const position of positions) {
        if (position.qty === 0)
            continue;
        const key = position.ticker.toUpperCase();
        const bucket = openByTicker.get(key);
        if (bucket)
            bucket.push(position);
        else
            openByTicker.set(key, [position]);
    }
    const pnlByTicker = new Map();
    for (const row of pnlTickers) {
        pnlByTicker.set(row.ticker.toUpperCase(), row);
    }
    const tickers = new Set([...openByTicker.keys(), ...pnlByTicker.keys()]);
    const merged = [];
    for (const ticker of tickers) {
        const open = openByTicker.get(ticker) ?? [];
        const qty = open.reduce((acc, p) => acc + p.qty, 0);
        const open_pnl = open.length ? open.reduce((acc, p) => acc + p.pnl, 0) : null;
        const market = open.find((p) => p.market_price > 0)?.market_price ??
            (open[0]?.market_price ?? null);
        const breakeven = open.find((p) => typeof p.breakeven_sell_price === "number")?.breakeven_sell_price ?? null;
        const currency = open[0]?.currency ?? "RUB";
        merged.push({
            ticker,
            positions: open,
            qty,
            avg_price: weightedAvg(open),
            market_price: market,
            breakeven_sell_price: typeof breakeven === "number" ? breakeven : null,
            open_pnl,
            currency,
            pnl: pnlByTicker.get(ticker) ?? null,
        });
    }
    merged.sort((a, b) => {
        const aShort = a.qty < 0 ? 0 : 1;
        const bShort = b.qty < 0 ? 0 : 1;
        if (aShort !== bShort)
            return aShort - bShort;
        const aFlat = a.qty === 0 ? 0 : 1;
        const bFlat = b.qty === 0 ? 0 : 1;
        if (aFlat !== bFlat)
            return aFlat - bFlat;
        return a.ticker.localeCompare(b.ticker);
    });
    return merged;
}
